import { createClient } from '@supabase/supabase-js';

// HARDCODED - Works immediately
const supabaseUrl = 'https://gklwqkiypeeenkvqcezr.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdrbHdxa2l5cGVlZW5rdnFjZXpyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg0OTI1OTMsImV4cCI6MjA4NDA2ODU5M30.WsOQWZ_6lZVbIjaxLdHQqRipwYsfyEIdzSld4bFhovQ';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);